interface PageTabsProps {
  active: string;
  onChange: (tab: string) => void;
  tabs: { id: string; label: string }[]; // 👈 dynamic tabs array
}

const PageTabs = ({ active, onChange, tabs }: PageTabsProps) => {
  return (
    <div className="border-bottom mb-3 d-flex border-border">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          className={
            "px-3 py-2 border-0 bg-transparent fs-16 fw-medium " +
            (active === tab.id
              ? "bg-primary text-white fw-medium border-bottom-0 px-4"
              : "text-black2D")
          }
          style={{
            borderTopLeftRadius: 7,
            borderTopRightRadius: 7,
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default PageTabs;
